// Chế độ sáng/tối: mặc định theo hệ điều hành (tokens.css `prefers-color-scheme`); người dùng chọn tay → ghi
// `data-theme` lên <html> và nhớ trong localStorage (chỉ là tùy chọn giao diện của trình duyệt này).
const KEY = 'swchat.theme';
type Theme = 'light' | 'dark';

function stored(): Theme | undefined {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : undefined;
  } catch {
    return undefined;
  }
}

/** Gọi khi khởi động: áp lựa chọn đã lưu (nếu có). */
export function applyStoredTheme() {
  const t = stored();
  if (t) document.documentElement.dataset.theme = t;
}

/** Giao diện đang hiệu lực (lựa chọn tay, không thì theo hệ điều hành). */
export function readTheme(): Theme {
  const t = document.documentElement.dataset.theme;
  if (t === 'light' || t === 'dark') return t;
  return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/** Đổi sáng ↔ tối, lưu lựa chọn; trả giao diện mới. */
export function toggleTheme(): Theme {
  const next: Theme = readTheme() === 'dark' ? 'light' : 'dark';
  setThemeSetting(next);
  return next;
}

/** Lựa chọn của thiết bị này: 'system' khi chưa chọn tay. Chế độ màu là cài đặt RIÊNG từng thiết bị (không đồng bộ). */
export function readThemeSetting(): 'system' | Theme {
  return stored() ?? 'system';
}

/** Áp lựa chọn giao diện cho thiết bị này: `system` bỏ lựa chọn tay và theo hệ điều hành. Báo cho giao diện đang mở cập nhật. */
export function setThemeSetting(theme: 'system' | Theme) {
  try {
    if (theme === 'system') {
      delete document.documentElement.dataset.theme;
      localStorage.removeItem(KEY);
    } else {
      document.documentElement.dataset.theme = theme;
      localStorage.setItem(KEY, theme);
    }
  } catch {
    // Trình duyệt chặn localStorage → chỉ áp cho phiên này.
  }
  window.dispatchEvent(new Event(THEME_EVENT));
}

/** Sự kiện báo giao diện đã đổi chế độ màu (nút ở thanh điều hướng, hộp thoại cài đặt). */
export const THEME_EVENT = 'swchat:theme';
